import { useGetAllAccounts, useGetNormalAccounts } from '../../api/auth'
import { formatDate, formatPhoneNumber, formatRole } from '../../utils/formatters'

export default function AccountsTable() {
  const { data: accounts, isLoading } = useGetAllAccounts()
  return (
    <table className="table-auto bg-white border text-right min-w-[1000px]">
      <thead>
        <tr className='bg-slate-200'>
          <th className="p-3 w-[25%]">نام</th>
          <th className="p-3 w-[25%]">ایمیل</th>
          <th className="p-3 w-[10%]">نقش</th>
          <th className="p-3 w-[15%] text-left">شماره تلفن</th>
          <th className="p-3 w-[15%] text-left">تاریخ ایجاد</th>
        </tr>
      </thead>
      <tbody className='font-light text-sm'>
        {accounts?.map(({ fullName, email, phoneNumber, role, createdAt }) => (
          <tr>
            <td className="p-2">{fullName}</td>
            <td className="p-2">{email}</td>
            <td className="p-2">{formatRole(role)}</td>
            <td className="p-2 text-left">{formatPhoneNumber(phoneNumber)}</td>
            <td className="p-2 text-left">
              {formatDate(createdAt, 'short')}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
